import axios from 'axios';
import { API } from '../../constants';

const createAction = name => ({
    GET_NAVBAR_CATEGORY_SUCCESS: `${name}_GET_NAVBAR_CATEGORY_SUCCESS`,
    GET_NAVBAR_CATEGORY_ERROR: `${name}_GET_NAVBAR_CATEGORY_ERROR`
});

export const NAVIGATION = createAction('NAVIGATION');

export const getNavbarCategory = () => async (dispatch, getState) => {
    try {
        const { currentLanguage } = getState().language;
        const result = await axios
            .get(API.NAVBAR_CATEGORY, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));
        
        dispatch({
            type: NAVIGATION.GET_NAVBAR_CATEGORY_SUCCESS,
            payload: result
        });
    } catch (error) {
        dispatch({
            type: NAVIGATION.GET_NAVBAR_CATEGORY_ERROR
        });
    }
};
